import styled from "styled-components";
import {CFlex, DText, Flex} from "../../styles/MarketStyles";
import ConnectionStatus from "./ConnectionStatus";
import {useMakePairs} from "../../hooks/usePairsHook";
import {loadPersistedData, persistData} from "../../utils/persistor";
import {useEffect, useRef, useState} from "react";
import {formatNumber} from "../../utils/common";
import { BsViewList } from 'react-icons/bs'
import {CgCheck} from "react-icons/cg";
import Text from "../../utils/Text";
import {useMainContext} from "../../contexts/main";

const BottomDetails = (props) => {

    const ref = useRef()
    const { setMarket } = useMainContext()
    const starred = loadPersistedData("starred")
    const [filters, setFilters] = useState({
        search: "", pair: null, starred: starred ? starred : []
    })

    const [selectMode, setSelectMode] = useState(false)
    const [list, setList] = useState([])
    const [mode, setMode] = useState('popular')

    const { fullPairs } = useMakePairs({ filters, setFilters })

    useEffect(() => {
        if (mode === 'popular')
            setList(fullPairs.filter(item => item.pair === 'irt'))
        else
            setList(fullPairs.filter(item => item.starred))
    }, [mode, fullPairs])

    const changeMarket = (item) => {
        setMarket({ coin: item.coin, pair: item.pair })
    }

    return (
        <Wrapper {...props}>
            <Flex fw fh justify={'flex-start'}>
                <Item>
                    <ConnectionStatus />
                </Item>
                <Flex ref={ref} width={'75%'} justify={'flex-start'}>
                    <Flex style={{ margin: '0 5px' }} onClick={() => setSelectMode(state => !state)}>
                        <ModesIcon size={16} />
                        {selectMode &&
                            <SelectModeWrapper>
                                <CFlex fw align={'flex-start'}>
                                    {['popular', 'favorite'].map(item => (
                                        <Flex style={{ margin: '5px 0', cursor: 'pointer' }} onClick={() => setMode(item)}>
                                            <DText main={mode !== item} color={mode === item && '#ffc800' } fontSize={'s'}>
                                                <Text tid={item} />
                                            </DText>
                                            {mode === item &&
                                                <CgCheck size={18} color={'#ffc800'} />
                                            }
                                        </Flex>
                                    ))}
                                </CFlex>
                            </SelectModeWrapper>
                        }
                    </Flex>
                    {list?.slice(0, ref?.current?.offsetWidth / 180)?.map(item => (
                        <Item style={{ width: '180px' }} onClick={() => changeMarket(item)}>
                            <Flex>
                                <DText main fontSize={'ss'}>
                                    {`${item.coin?.toUpperCase()}/${item.pair?.toUpperCase()}`}
                                </DText>
                                <ChangeText positive={item._24change >= 0}>
                                    {formatNumber(item._24change, {point: 2})}
                                </ChangeText>
                                <DText primary fontSize={'ss'}>
                                    {formatNumber(item.price, { point: 2, type: item.pair })}
                                </DText>
                            </Flex>
                        </Item>
                    ))}
                </Flex>
            </Flex>
        </Wrapper>
    )
}


const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 24px;
  border-top: 1px solid ${props => props.theme.color}20;
  background-color: ${props => props.theme.secondaryBg};
  direction: ltr;
  z-index: 202;
`

const Item = styled.div`
  padding: 3px 25px 0 10px;
  border-right: 1px solid ${props => props.theme.color}20;
  cursor: pointer;
`

const ChangeText = styled.div`
  font-size: 0.7rem;
  color: ${props => props.positive ? props.theme.mainGreen : props.theme.mainRed};
  margin: 0 5px;
`

const ModesIcon = styled(BsViewList)`
  color: ${props => props.theme.color};
  cursor: pointer;
`

const SelectModeWrapper = styled.div`
  padding: 8px;
  border-radius: 4px;
  background-color: ${props => props.theme.settingBg};
  position: absolute;
  bottom: 24px;
  z-index: 1000;
  direction: ${props => props.theme.english ? 'ltr' : 'rtl'};
`

export default BottomDetails
